import { render, staticRenderFns } from "./NumberAnimation.vue?vue&type=template&id=64c0b347&scoped=true"
import script from "./NumberAnimation.vue?vue&type=script&lang=js"
export * from "./NumberAnimation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c0b347",
  null
  
)

export default component.exports